exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sankey-chart svg{width:100%;height:auto}.sankey-chart svg .axis .domain,.sankey-chart svg .axis .tick line{display:none}.sankey-chart svg .axis .tick text{text-transform:uppercase;font-size:10px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52aebe78","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Charts/Sankey.vue
// module id = 375
// module chunks = 0